/* eslint-disable max-len */
export const ApiErrors = {
  inactiveAccount: 'Please check your email to activate your account',
  invalidOtp: 'Otp is not valid',
  passwordResetRequired:
    'Your password must be reset before you can sign in. Please use Forgot password.',
  pointsEngineAlreadyRunning:
    'Cannot run until the points engine or another promotion has finished processing',
  tooManyPasswordAttempts:
    'Too many failed login attempts. Please reset your password to continue.',
  userWithEmailExists: 'User with the provided email already exists',
  userWithPhoneExists: 'User with the provided telephone already exists',
  userWithPhoneDoesNotExist: 'We cannot find an account associated with that phone number',
} as const;
